module.exports = __webpack_public_path__ + "models/doorbell_8bfab28a8a13d2c515e451d56831216a.glb";